export const IconLanguage = () => (<i className='icon-common-language'/>)
